module.exports = __webpack_public_path__ + "img/PPMPRA8.52af3f29.png";